import { useEffect, useState } from "react";
import { X } from "react-feather";
import styles from "./moveout-checklist.module.css";
import { Button } from "@mui/material";
import ArrivalForm from "./components/arrival-form/ArrivalForm";
import FormHeader from "./components/FormHeader";
import FormFooter from "./components/FormFotter";
import FormComments from "./components/Comments";
import { toast } from "react-smart-toaster";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../components/Loader";
import MoveOutChecklistPDF from "./components/MoveOutChecklistPDF";

const MoveOutChecklist = ({ setMoveOutChecklistOpen, moveOutChecklistOpen, tenantId, isFormSubmitted }) => {
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [moveOutCheckListInfo, setMoveOutCheckListInfo] = useState(null);
  const [signatureCommentsData, setSignatureCommentsData] = useState({});
  const [moveOutChecklistPDFContent, setMoveOutChecklistPDFContent] = useState();

  useEffect(() => {
    if (tenantId && !isFormSubmitted) {
      getMoveOutCheckListInfo();
    }
    if (tenantId && isFormSubmitted) {
      getMoveOutCheckListPDFInfo();
    }
  }, [tenantId]);

  const onSubmitMoveOutCheckListForm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    let postData = signatureCommentsData;

    const isManagerSigned = !!postData?.manager_sign;

    const isTenant1Required = !!moveOutCheckListInfo?.tenant1_name;
    const isTenant2Required = !!moveOutCheckListInfo?.tenant2_name;
    const isTenant3Required = !!moveOutCheckListInfo?.tenant3_name;

    const isTenant1Signed = !isTenant1Required || !!postData?.tenant1_sign;
    const isTenant2Signed = !isTenant2Required || !!postData?.tenant2_sign;
    const isTenant3Signed = !isTenant3Required || !!postData?.tenant3_sign;

    const allSigned = isManagerSigned && isTenant1Signed && isTenant2Signed && isTenant3Signed;

    if (!allSigned) {
      toast.error("Signatures missing. Kindly ensure all tenants and the property manager have signed before submitting.");
      return;
    }

    setLoading(true);
    return axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/submit-move-out-report/${tenant_id}`, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      toast.success("Move-Out Checklist submitted successfully!");
      setTimeout(() => setMoveOutChecklistOpen(false), 500);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const onSubmitArrivalForm = async (formData, sectionName, images, imageSectionName) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    let postData = {};
    postData[sectionName] = formData;
    if (images.length) {
      postData[imageSectionName] = images;
    }

    return axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-out-report/${tenant_id}`, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      toast.success("Your information has been saved successfully.");
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const getMoveOutCheckListInfo = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    return axios.get(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-out-report/${tenant_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setMoveOutCheckListInfo(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onSubmitSignatureCommentsData = (key, value) => {
    setSignatureCommentsData((previous) => ({ ...previous, [key]: value }));
  };

  const getMoveOutCheckListPDFInfo = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    return axios.get(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-out-report-file-content/${tenant_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setMoveOutChecklistPDFContent(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    <div className={moveOutChecklistOpen === true ? `${styles.CheckListFormSec} ${styles.Open}` : `${styles.CheckListFormSec}`
    }>
      <div className={`${styles.PanelUnder}`}>
        <div className={`${styles.PanelCloasesec}`}>
          <button onClick={(e) => setMoveOutChecklistOpen(false)}>
            <X />
          </button>
        </div>
        {!isFormSubmitted && (<div>
          <FormHeader moveOutCheckListInfo={moveOutCheckListInfo} />
          <div className={`${styles.FormMainSec}`}>
            <div className="FormAccording Theme">
              <ArrivalForm
                onSubmitArrivalForm={onSubmitArrivalForm}
                tenantId={tenantId}
                setLoading={setLoading}
                moveOutCheckListInfo={moveOutCheckListInfo}
              />
              <FormComments
                moveOutCheckListInfo={moveOutCheckListInfo}
                onSubmitSignatureCommentsData={onSubmitSignatureCommentsData}
              />
              <FormFooter
                moveOutCheckListInfo={moveOutCheckListInfo}
                onSubmitSignatureCommentsData={onSubmitSignatureCommentsData}
                setLoading={setLoading}
              />
              <div className={`${styles.ButtonAction}`}>
                <Button className={`${styles.CancelPopupBU}`} onClick={(e) => setMoveOutChecklistOpen(false)}>Cancel</Button>
                <Button className={`${styles.SubmitPopupBU}`} onClick={onSubmitMoveOutCheckListForm}>Submit</Button>
              </div>
            </div>
          </div>
        </div>)}
        {isFormSubmitted === 1 && (<div>
          <MoveOutChecklistPDF moveOutChecklistPDFContent={moveOutChecklistPDFContent} />
        </div>)}
      </div>
    </div>
  </>);
};

export default MoveOutChecklist;